<template>
  <vue-d3 :onExportPng="handleExportPng" :showExport="showExport">
    <div ref="vis-ref"></div>
  </vue-d3>
</template>

<script>
import { Gauge } from './Gauge';
import VueD3 from '../VueD3.vue';

export default {
  name: 'GaugeWrapper',
  components: {
    VueD3,
  },
  props: {
    exportTitle: String,
    exportFileName: String,
    showExport: {
      type: Boolean,
      default: false,
    },
    percentage: {
      type: Number,
      required: true,
    },
    width: Number,
    color: [String, Function, Array],
    backgroundColor: String,
    label: [String, Array],
  },
  data() {
    return {
      gaugeInstance: null,
    };
  },
  mounted() {
    this.gaugeInstance = new Gauge({
      target: this.$refs['vis-ref'],
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,
      percentage: this.percentage,
      width: this.width,
      color: this.color,
      backgroundColor: this.backgroundColor,
      label: this.label,
    });
    this.$emit('init', this.gaugeInstance);
  },
  watch: {
    percentage(newValue, oldValue) {
      if (this.gaugeInstance) {
        this.gaugeInstance.updateData(newValue);
      }
    },
  },
  methods: {
    handleExportPng() {
      if (this.gaugeInstance) {
        this.gaugeInstance.exportToPng();
      }
    },
  },
};
</script>
